export default "__VITE_ASSET__R9eC2$bb__"